import { createApp } from "vue";
import App from "./App.vue";
import "./assets/sdgs03.css";
// import "./assets/sdgs-main02.js";

createApp(App).mount("#app");
